<template>
	<TripFormSection
		:title="$t('web.edit.trip.destination.title')"
		:is-complete="Boolean(destination)"
		icon="double-marker"
	>
		<GoogleBrowser
			:model-value="destinationName"
			:types="['(regions)']"
			:placeholder="String($t('web.trip.edit.destination.placeholder'))"
			size="s"
			keep-selected
			:is-x-s="isXS"
			:error="error"
			@select="chooseDestination"
		/>
	</TripFormSection>
</template>

<script setup lang="ts">
	import { computed } from 'vue'
	import { Destination2 } from '~/models/Destination'

	interface Props {
		isXS: boolean
		error?: string
	}
	defineProps<Props>()

	const emit = defineEmits(['input'])

	const destination = defineModel<Destination2 | null>({ required: true })

	const destinationName = computed(() => {
		return destination.value?.name
	})

	const chooseDestination = (newValue: Destination2 | null) => {
		destination.value = newValue
		emit('input', destination.value)
	}
</script>
